var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilterFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03125 1L10.1296 5.11181L14.6886 5.83688L11.4265 9.10319L12.1457 13.6631L8.03125 11.57L3.91675 13.6631L4.63598 9.10319L1.37385 5.83688L5.93286 5.11181L8.03125 1Z",
    stroke: "#737373",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterFavorite);
export default __webpack_public_path__ + "static/media/icon_filter_favorite.75062c6adf70a46f78b3c4e2b8b3eb84.svg";
export { ForwardRef as ReactComponent };